import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  Button,
  Form,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Oval } from "react-loader-spinner";
import { MdDownload, MdOutlineAssignment, MdCloudUpload } from "react-icons/md";
import Loading from "../../../components/common/Loading";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const day = d.getDate().toString().padStart(2, "0");
  const month = d.toLocaleString("default", { month: "long" });
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

/**
 * AssignmentsSection
 * Self-contained Assignments card: fetches the assignment list for a course,
 * lets the student upload a new assignment, and renders the list with a
 * download action. Fully API-driven — no data needs to be passed in besides
 * the `course` object.
 *
 * Usage:
 *   <AssignmentsSection course={course} />
 */
const AssignmentsSection = () => {
  //   const course =
  //     JSON.parse(localStorage.getItem("course"))[0] ?? location.state?.course;

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [resources, setResources] = useState([]);
  const [isResourceLoading, setIsResourceLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [course, setcourse] = useState("");
  const courseData = course?.student;

  const users = JSON.parse(localStorage.getItem("users"));

  const getEnrolledCourses = async () => {
    try {
      const response = await axios.post(webServiceUrl.enrolledCourses, {
        users,
      });
      console.log(response.data.enrolledCourses, "resposne data");
      setcourse(response.data.enrolledCourses[0]);
      await localStorage.setItem(
        "course",
        JSON.stringify(response.data.enrolledCourses),
      );
    } catch (error) {
    } finally {
    }
  };

  useEffect(() => {
    getEnrolledCourses();
  }, [getEnrolledCourses]);
  const [uploadedData, setUploadedData] = useState({
    school_code: course?.school_code,
    student_id: courseData?.student_id,
    class: courseData?.class,
    section: courseData?.section,
    subject: course?.school_name,
    title: "",
    due_date: "",
    given_by: courseData?.student_name,
    file_path: "",
    level: courseData?.level,
    combination_code: courseData?.combination_code,
  });

  const getResources = async () => {
    try {
      setIsResourceLoading(true);
      const response = await axios.post(webServiceUrl.resources, {
        school_code: 900,
        class_name: courseData?.class,
        section: courseData?.section,
        level: courseData?.level,
        combination_code: courseData?.combination_code,
      });
      setResources(response?.data?.data ?? []);
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => setIsResourceLoading(false), 800);
    }
  };

  const validateAssignmentData = (data) => {
    const newError = {};
    if (!data?.title) newError.title = "Title is required!";
    if (!data?.file_path) newError.file_path = "Please upload a file!";
    setErrors(newError);
    return Object.keys(newError).length === 0;
  };

  const uploadAssignments = async () => {
    try {
      const isValid = validateAssignmentData(uploadedData);
      if (!isValid) return;

      setIsUploading(true);
      const formData = new FormData();
      Object.entries(uploadedData).forEach(([key, value]) => {
        if (key !== "file_path") {
          formData.append(key, value);
        } else {
          formData.append("assignment_file", value); // actual File object
        }
      });

      const response = await axios.post(
        webServiceUrl.upload_assignments,
        formData,
      );

      if (response?.data?.success) {
        toast.success(response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        getResources();
        setShow(false);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error?.response?.data?.message);
      toast.error(error?.response?.data?.message || "Upload failed");
    } finally {
      setTimeout(() => setIsUploading(false), 800);
    }
  };

  useEffect(() => {
    getResources();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [course?.school_code]);

  return (
    <>
      <style>{`
        .assign-card {
          border: none;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 4px 18px rgba(20, 100, 45, 0.08);
        }
        .assign-header {
          background: linear-gradient(135deg, #2e9e4a 0%, #1f7d38 100%);
          padding: 22px 28px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .assign-header h4 {
          color: #ffffff;
          font-weight: 600;
          margin: 0;
          font-size: 1.15rem;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .assign-upload-btn {
          background: #ffffff;
          color: #1f7d38;
          border: none;
          border-radius: 10px;
          padding: 9px 18px;
          font-weight: 600;
          font-size: 0.9rem;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: all 0.2s ease;
        }
        .assign-upload-btn:hover {
          background: #eafaef;
          color: #145c28;
          transform: translateY(-1px);
        }
        .assign-body {
          background: #fbfdfb;
          padding: 20px 24px 26px;
        }
        .assign-table thead th {
          background: #eef8f0;
          color: #1f7d38;
          font-weight: 600;
          font-size: 0.82rem;
          text-transform: uppercase;
          letter-spacing: 0.4px;
          border: none;
          padding: 12px 14px;
        }
        .assign-table tbody td {
          vertical-align: middle;
          padding: 14px;
          font-size: 0.9rem;
          color: #33403a;
          border-color: #eef1ee;
        }
        .assign-table tbody tr {
          transition: background 0.15s ease;
        }
        .assign-table tbody tr:hover {
          background: #f3fbf4;
        }
        .assign-title-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-weight: 600;
          color: #1f2937;
        }
        .assign-download-btn {
          width: 34px;
          height: 34px;
          border-radius: 8px;
          background: #eafaef;
          color: #1f7d38;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
        }
        .assign-download-btn:hover {
          background: #1f7d38;
          color: #ffffff;
        }
        .assign-empty {
          padding: 40px 0;
          text-align: center;
          color: #8a978f;
        }
        .assign-modal-header {
          background: linear-gradient(135deg, #2e9e4a 0%, #1f7d38 100%);
          border: none;
        }
        .assign-modal-header .modal-title h3 {
          color: #ffffff;
          font-size: 1.1rem;
          font-weight: 600;
          margin: 0;
        }
        .assign-modal-header .btn-close {
          filter: invert(1) brightness(2);
        }
        .assign-modal-body {
          padding: 26px 26px 10px;
          background: #fbfdfb;
        }
        .assign-form-label {
          font-weight: 600;
          color: #33403a;
          font-size: 0.88rem;
        }
        .assign-input {
          border-radius: 10px;
          border: 1px solid #dfe7e2;
          padding: 10px 14px;
        }
        .assign-input:focus {
          border-color: #2e9e4a;
          box-shadow: 0 0 0 3px rgba(46, 158, 74, 0.15);
        }
        .assign-save-btn {
          background: #1f7d38;
          border: none;
          border-radius: 10px;
          font-weight: 600;
          padding: 10px 30px;
        }
        .assign-save-btn:hover {
          background: #17612b;
        }
      `}</style>

      <Card className="assign-card">
        <div className="assign-header">
          <h4>
            <MdOutlineAssignment size={22} />
            Assignments
          </h4>
          <button
            type="button"
            className="assign-upload-btn"
            onClick={handleShow}
          >
            <MdCloudUpload size={18} />
            Upload Assignment
          </button>
        </div>

        <Modal scrollable show={show} onHide={handleClose} centered>
          <Modal.Header closeButton className="assign-modal-header">
            <Modal.Title className="h5">
              <h3>Upload Assignment</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="assign-modal-body">
            <Form.Group className="mb-3 form-group">
              <Form.Label className="assign-form-label">Title</Form.Label>
              <Form.Control
                className="assign-input"
                type="text"
                placeholder="Enter Title"
                value={uploadedData.title}
                onChange={(e) => {
                  setUploadedData({ ...uploadedData, title: e.target.value });
                  setErrors((prev) => ({ ...prev, title: "" }));
                }}
              />
              {errors?.title && (
                <p className="text-danger ps-1 pb-0 mb-0 mt-1">
                  {errors.title}
                </p>
              )}
            </Form.Group>

            <Form.Group className="mb-3 form-group">
              <Form.Label className="assign-form-label">Choose file</Form.Label>
              <Form.Control
                className="assign-input"
                type="file"
                id="assignmentFile"
                onChange={(e) => {
                  const files = e.target.files;
                  if (files.length > 0) {
                    setUploadedData({ ...uploadedData, file_path: files[0] });
                    setErrors((prev) => ({ ...prev, file_path: "" }));
                  }
                }}
              />
              {errors?.file_path && (
                <p className="text-danger ps-1 pb-0 mb-0 mt-1">
                  {errors.file_path}
                </p>
              )}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="border-0 mb-2">
            <Button
              className="assign-save-btn d-flex align-items-center gap-2"
              onClick={uploadAssignments}
              disabled={isUploading}
            >
              {isUploading && <Loading size="small" />}
              Save
            </Button>
          </Modal.Footer>
        </Modal>

        <Card.Body className="assign-body">
          <div className="table-responsive">
            <Table className="assign-table" borderless hover>
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Title</th>
                  {/* <th>Subject</th> */}
                  <th>Due Date</th>
                  {/* <th>Time</th> */}
                  <th>Author</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {isResourceLoading ? (
                  <tr>
                    <td colSpan="7" className="border-0">
                      <div className="d-flex justify-content-center pt-3 pb-2">
                        <Oval
                          height="50"
                          width="50"
                          color="#1f7d38"
                          secondaryColor="#1f7d38"
                        />
                      </div>
                    </td>
                  </tr>
                ) : resources.length > 0 ? (
                  resources.map((file, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <span className="assign-title-badge">
                          <MdOutlineAssignment color="#1f7d38" size={16} />
                          {file.title}
                        </span>
                      </td>
                      {/* <td>{file.subject}</td> */}
                      <td>{formatDate(file.due_date)}</td>
                      {/* <td>
                        {file.start_time?.slice(0, 5)} -{" "}
                        {file.end_time?.slice(0, 5)}
                      </td> */}
                      <td>{file.given_by}</td>
                      <td>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Download</Tooltip>}
                        >
                          <a
                            href={file.file_path}
                            download
                            target="_blank"
                            rel="noreferrer"
                            className="assign-download-btn"
                          >
                            <MdDownload size={18} />
                          </a>
                        </OverlayTrigger>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="border-0">
                      <div className="assign-empty">
                        <MdOutlineAssignment size={36} color="#c7d5cc" />
                        <p className="mb-0 mt-2">No assignments found</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default AssignmentsSection;
